import React from 'react';
import { TextField } from '@mui/material';
import { getCommonTextFieldStyles } from '../../_utils/fieldInputHelpers';

export interface BaseTextInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  maxLength?: number;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  multiline?: boolean;
  minRows?: number;
}

const BaseTextInput: React.FC<BaseTextInputProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Enter text value',
  required = false,
  disabled = false,
  error,
  helperText,
  maxLength,
  size = 'small',
  fullWidth = true,
  multiline = false,
  minRows,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = event.target.value;

    // Only enforce maxLength if specified, but don't prevent input
    // Let the form validation handle error display
    if (maxLength && newValue.length > maxLength) {
      return; // Still prevent input beyond maxLength
    }

    onChange(newValue);
  };

  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      error={!!error}
      helperText={error || helperText}
      size={size}
      fullWidth={fullWidth}
      variant='outlined'
      multiline={multiline}
      minRows={minRows}
      inputProps={{
        maxLength,
      }}
      sx={getCommonTextFieldStyles()}
    />
  );
};

export default BaseTextInput;
